/* eslint-disable react/function-component-definition, react/prop-types */
import React, { useMemo } from 'react'
import { ButtonGroup, Col } from 'react-bootstrap'
import paginationFactory from 'react-bootstrap-table2-paginator'
import { Button } from '../Button'

const sizePerPageList = [
  {
    text: '10',
    value: 10,
  },
  {
    text: '25',
    value: 25,
  },
  {
    text: '50',
    value: 50,
  },
  {
    text: '100',
    value: 100,
  },
]

const sizePerPageRenderer =
  (rowCount, loading) =>
  ({ options, currSizePerPage, onSizePerPageChange }) => (
    <ButtonGroup>
      {options
        .filter((option, index) => {
          const zero = { page: 0 }
          const previousOption = options[index - 1] || zero
          return previousOption.page < rowCount
        })
        .map((option) => (
          <Button
            key={option.text}
            disabled={loading}
            onClick={() => onSizePerPageChange(option.page)}
            variant={currSizePerPage === `${option.page}` ? 'primary' : 'light'}
          >
            {option.text}
          </Button>
        ))}
    </ButtonGroup>
  )

const pageListRenderer =
  (loading) =>
  ({ pages, onPageChange }) => (
    <Col className="d-flex justify-content-end">
      <ButtonGroup>
        {pages.map((item) => (
          <Button
            key={item.page}
            disabled={item.disabled || loading}
            onClick={() => onPageChange(item.page)}
            variant={item.active ? 'primary' : 'light'}
          >
            {item.title}
          </Button>
        ))}
      </ButtonGroup>
    </Col>
  )

const usePagination = ({ rowCount, page, sizePerPage, isRemote, loading, additionalSizePerPageValues }) => {
  const pagination = useMemo(
    () =>
      paginationFactory({
        sizePerPageList: sizePerPageList.concat(additionalSizePerPageValues),
        sizePerPageRenderer: sizePerPageRenderer(rowCount, loading),
        pageListRenderer: pageListRenderer(loading),
        firstPageTitle: '<<',
        prePageTitle: '<',
        nextPageTitle: '>',
        lastPageTitle: '>>',
        totalSize: isRemote ? rowCount : undefined, // ignore controls if NOT remote
        page,
        sizePerPage,
      }),
    [rowCount, page, sizePerPage, isRemote, loading, additionalSizePerPageValues],
  )

  return pagination
}

export default usePagination
